import { render, staticRenderFns } from "./ManageRequests.vue?vue&type=template&id=5b32df44&scoped=true&"
import script from "./ManageRequests.vue?vue&type=script&lang=js&"
export * from "./ManageRequests.vue?vue&type=script&lang=js&"
import style0 from "./ManageRequests.vue?vue&type=style&index=0&id=5b32df44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b32df44",
  null
  
)

export default component.exports